/*=========================================================================================
  File Name: moduleUnit.js
  Description: Units Module
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import state from "./moduleFloorState";
import mutations from "./moduleFloorMutations";
import actions from "./moduleFloorActions";
import getters from "./moduleFloorGetters";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
